import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'underscore';

@Component({
    selector: 'app-countrychange',
    templateUrl: './Countrychange.component.html',
    styleUrls: ['./Countrychange.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class CountrychangeComponent implements OnInit {
    dialogTitle: string;
    action: string;
    item: any;
    constructor(
        public matDialogRef: MatDialogRef<CountrychangeComponent>
    ) {
    }

    Action(action: string): any {
        this.matDialogRef.close(action);        
    }
    ngOnInit(): void {
    }
}
